import React, { useEffect, useRef, useState } from 'react'
import { CToast, CToastBody, CToastHeader, CToaster } from '@coreui/react'
import { useDispatch, useSelector } from 'react-redux'

// import action
import { toast } from '../redux/toast/toast.action'

const ToastCAlert = () => {
  const dispatch = useDispatch()

  // state
  const [display, addDisplay] = useState(0)
  const [show, setShow] = useState(false)
  const [delay, setDelay] = useState(3000)
  const toaster = useRef()

  //redux-state
  const { type, message } = useSelector((state) => state.toast)
  const handleMouseEnter = () => {
    setDelay(3000)
    // Logic to prevent auto-hide, e.g., by setting a state variable
  };
  
  const handleMouseLeave = () => {
    setDelay(3000)
    // Logic to allow auto-hide, e.g., by resetting the state variable
  };
  const exampleToast = (
    <CToast visible={true}  position="static" delay={delay} autohide={true} autohideDuration={delay}
    onMouseEnter={handleMouseEnter}
    onMouseLeave={handleMouseLeave}
    >
      <CToastHeader closeButton>
        <svg
          className="rounded me-2"
          width="20"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
          role="img"
        >
          <rect width="100%" height="100%" fill="#007aff"></rect>
        </svg>
        <strong className="me-auto">Matrix Wallet</strong>
      </CToastHeader>
      <CToastBody style={{ color: type === 'success' ? 'green' : 'red' }}>{message}</CToastBody>
    </CToast>
  )

  useEffect(() => {
    if (type && type !== undefined) {
      addDisplay(exampleToast)
      toast({}, dispatch)
    }
  }, [type])

  return <CToaster ref={toaster} push={display} placement="top-end" />
}

export default ToastCAlert
